<template>
  <div>
    <BaseFrame
      cancelText=""
      clearText=""
      idText="订单编码"
      :infosArr="infos"
      :subInfosArr="subInfosArr"
      :id="code"
      :submitText="submitText"
      :showCtrls="true"
      :otherBtnText="SfOrderStatusTxt"
      @otherClick="handleClick"
      :logisticsBtnText="logisticsBtnText"
      @logisticsClick="handleLogisticsClick"
      :coldChainBtnText="coldChainBtnText"
      @coldChainClick="handleColdChainClick"
      @submit="handleSubmit"
      :printText="editCode"
      @print="handleEditCode"
      >
      <div class="container" slot="content">
        <div class="tableContainer">
          <lk-card title="商品信息">
            <lk-form v-if="isColdChain||saleData.saleExpress.transStartTime||saleData.saleExpress.transEndTime" :label-width='120' label-position='right' :model='saleData.saleExpress'
              ref="saleExpress" :rules='saleExpress'>
              <lk-row :gutter='16'>
                <lk-col span='7'>
                  <lk-form-item label='起运时间:' prop='transStartTime'>
                    <timeStampDatePicker v-model='saleData.saleExpress.transStartTime'  v-if="isColdChain">
                    </timeStampDatePicker>
  <span v-else>{{saleData.saleExpress.transStartTime|formatDate}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span='7'>
                  <lk-form-item label='送达时间:' prop='transEndTime'>
                    <timeStampDatePicker v-model='saleData.saleExpress.transEndTime' v-if="isColdChain">
                    </timeStampDatePicker>
  <span v-else>{{saleData.saleExpress.transEndTime|formatDate}}</span>

                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-form>
            <lk-table border :columns='goodsColumns' :data='saleData.saleOrderDetailList'></lk-table>
          </lk-card>
        </div>
        <div class="nextStep">
          <div class="content">
            <lk-card :title='userStr+"信息"' v-if="saleData.saleBuyerInfo">
              <div>
                <lk-form :label-width='120' label-position='right' :model='saleData.saleBuyerInfo'
                  ref="saleBuyerInfo" :rules='saleBuyerInfo'>
                  <lk-row :gutter='16'>
                    <lk-col span='7'>
                      <lk-form-item :label='userStr+"姓名:"' prop='buyerName'>
                        <span>{{saleData.saleBuyerInfo.buyerName}}</span>
                      </lk-form-item>
                    </lk-col>
                    <lk-col span='7' offset='1'>
                      <lk-form-item :label='userStr+"年龄:"' prop='buyerAge'>
                        <span>{{saleData.saleBuyerInfo.buyerAge}}</span>
                      </lk-form-item>
                    </lk-col>
                    <lk-col span='7' offset='1'>
                      <lk-form-item label='性别:' prop='buyerGender'>
                        <span>{{genderList[saleData.saleBuyerInfo.buyerGender]}}</span>
                      </lk-form-item>
                    </lk-col>
                  </lk-row>
                  <lk-row :gutter='16'>
                    <lk-col span='7'>
                      <lk-form-item label='证件号码:' prop='buyerIdCard'>
                        <!-- <span>{{saleData.saleBuyerInfo.buyerIdCard}}</span> -->
                        <CredentialsInput :able='false' v-model="saleData.saleBuyerInfo" codeKey="buyerIdCard"></CredentialsInput>
                      </lk-form-item>
                    </lk-col>
                    <lk-col span='7' offset='1'>
                      <lk-form-item label='联系方式:' prop='buyerPhone'>
                        <span>{{saleData.saleBuyerInfo.buyerPhone}}</span>
                      </lk-form-item>
                    </lk-col>
                    <lk-col span='7' offset='1' v-show="saleData.purchaseType===1">
                      <lk-form-item label='购买原因:' prop='buyerReason'>
                        <span>{{saleData.saleBuyerInfo.buyerReason}}</span>
                      </lk-form-item>
                    </lk-col>
                  </lk-row>
                </lk-form>
              </div>
            </lk-card>
          </div>
          <div class="content" v-if="saleData.salePrescription">
            <prescriptionDecoction
              v-if='saleData.retailType===3'
              v-model="saleData.salePrescription"
              :able='false'>
            </prescriptionDecoction>
            <prescriptionCommon
              v-else
              v-model="saleData.salePrescription"
              :showSpec='false'
              :showLink="false"
              :able='false'>
            </prescriptionCommon>
          </div>
          <div class="content" v-if="!saleData.salePrescription">
            <lk-card title="联系人信息">
              <lk-row>
                <div style="display:flex">
                  <lk-col>
                    <div style="display:flex;margin-right:20px">
                      <div>联系人:</div>
                      <div>{{(saleData.saleOrder && saleData.saleOrder.contact) || ''}}</div>
                    </div>
                  </lk-col>
                  <lk-col>
                    <div style="display:flex">
                      <div>联系人电话:</div>
                      <div>{{(saleData.saleOrder && saleData.saleOrder.contactPhone) || ''}}</div>
                    </div>
                  </lk-col>
                </div>
              </lk-row>
            </lk-card >
          </div>
          <div class="content" v-if="promoteDiscountVOList.length > 0">
            <DiscountInformation
              :promoteDiscountVOList = 'promoteDiscountVOList'
            />
          </div>
          <div class="content" >
            <lk-card title="预收信息">
              <lk-table :data='depositData' border :columns="depositCol"></lk-table>
              </lk-card >
          </div>

          <div class="content" >
            <lk-card title="应收收款信息">
              <lk-table :data='receiveData' border :columns="receiveCol"></lk-table>
              </lk-card >
          </div>

          <div class="content">
            <lk-card title="收款信息">
              <div>
                <lk-form :label-width='120' label-position='right'>
                  <lk-row :gutter='16'>
                    <lk-col span='7'>
                      <lk-form-item label='订单商品数量:'>
                        <span>{{orderGoodsCount}}</span>
                      </lk-form-item>
                    </lk-col>
                    <lk-col span='7' offset='1'>
                      <lk-form-item label='订单金额（元）:'>
                        <span>¥{{payData.totalAmount || 0}}</span>
                      </lk-form-item>
                    </lk-col>
                    <lk-col span='7' offset='1'>
                      <lk-form-item label='折扣金额（元）:'>
                        <span>¥{{payData.discount || 0}}</span>
                      </lk-form-item>
                    </lk-col>
                  </lk-row>
                  <lk-row :gutter='16'>
                    <lk-col span='7'>
                      <lk-form-item label='应收金额（元）:'>
                        <span>¥{{payData.amountWithoutDiscount || 0}}</span>
                      </lk-form-item>
                    </lk-col>
                    <lk-col span='7' offset='1'>
                      <lk-form-item label='实收金额（元）:'>
                        <span class="totalPay">¥{{payData.realProceedsAmount}}</span>
                      </lk-form-item>
                    </lk-col>
                    <lk-col span='7' offset='1'>
                      <lk-form-item label='找零（元）:'>
                        <span>¥{{payData.changeAmount}}</span>
                      </lk-form-item>
                    </lk-col>
                  </lk-row>
                  <lk-row :gutter='16'>
                    <lk-col span='7' >
                      <lk-form-item label='剩余应收:'>
                        <span>{{payData.receivables}}</span>
                      </lk-form-item>
                    </lk-col>
                    <lk-col span='7' offset='1'>
                      <lk-form-item label='订单类型:' >
                        <span>{{typeList[payData.type]}}</span>
                      </lk-form-item>
                    </lk-col>
                    <lk-col span='7' offset='1'>
                      <lk-form-item label='患者姓名:'>
                        <span>{{saleData.saleOrder.relatePatientName}}</span>
                      </lk-form-item>
                    </lk-col>
                  </lk-row>
                  <lk-row :gutter='16'>
                    <lk-col span='7'>
                      <lk-form-item label='联系方式:'>
                        <span>{{saleData.saleOrder.relatePatientPhone}}</span>
                      </lk-form-item>
                    </lk-col>
                    <lk-col span='7' offset='1'>
                      <lk-form-item label='收款完成时间:'>
                        <span>{{saleData.saleOrder.payTime | formatDate('YYYY-MM-DD HH:mm')}}</span>
                      </lk-form-item>
                    </lk-col>
                    <lk-col span='7' v-for="(item,index) in paymentList" :key="index"
                      :offset='index%3===1?0:1'>
                      <lk-form-item :label='item.proceedsTypeName+":"'>
                        <span>{{item.amount}}</span>
                      </lk-form-item>
                    </lk-col>
                  </lk-row>
                </lk-form>
              </div>
            </lk-card>
          </div>
          <div class="content" v-if="orderInfo.saleExpress">
            <lk-card title="配送信息">
              <lk-form :label-width='120' label-position='right'>
                <lk-row :gutter='16'>
                  <lk-col span='5'>
                    <lk-form-item label='配送方式:'>
                      <span>{{deliveryMethodList[saleData.saleExpress.deliveryMethod-1] || '其他'}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='5' offset='1' v-if="[3, 4].includes(saleData.saleExpress.deliveryMethod)">
                    <lk-form-item label='配送公司:'>
                      <span>{{saleData.saleExpress.company}}</span>
                    </lk-form-item>
                  </lk-col>
                   <lk-col span='5' offset='1' v-if="saleData.saleExpress.deliveryMethod === 2">
                    <lk-form-item label='配送渠道:'>
                      <span>{{saleData.saleExpress.deliveryChannelName}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='5' offset='1' v-if="saleData.saleExpress.deliveryMethod !== 1">
                    <lk-form-item label='配送单号:'>
                      <span>{{saleData.saleExpress.code}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='5' offset='1'>
                    <lk-form-item label='物流状态:'>
                      <span>{{saleData.saleExpress.receivedStatusName}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='5'>
                    <lk-form-item label='发货人姓名:'>
                      <span>{{saleData.saleExpress.consignorName}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='5'  offset='1'>
                    <lk-form-item label='发货人联系方式:'>
                      <span>{{saleData.saleExpress.consignorPhone}}</span>
                    </lk-form-item>
                  </lk-col>
                   <lk-col span='5' offset='1'>
                    <lk-form-item label='收货人姓名:'>
                      <span>{{saleData.saleExpress.name}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='5' offset='1'>
                    <lk-form-item label='收货人联系方式:'>
                      <span>{{saleData.saleExpress.phone}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='11'>
                    <lk-form-item label='发货城市:'>
                      <span>{{`${saleData.saleExpress.consignProvinceName}${saleData.saleExpress.consignCityName}${saleData.saleExpress.consignCountyName}`}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='11' offset='1'>
                    <lk-form-item label='发货详细地址:'>
                      <span>{{saleData.saleExpress.consignAddress}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='11'>
                    <lk-form-item label='收货城市:'>
                      <span>{{`${saleData.saleExpress.provinceName}${saleData.saleExpress.cityName}${saleData.saleExpress.countyName}`}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='11' offset='1'>
                    <lk-form-item label='收货详细地址:'>
                      <span>{{saleData.saleExpress.address}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='5'>
                    <lk-form-item label='发货时间:'>
                      <span>{{saleData.saleExpress.expressTime | formatDate}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='5' offset='1'>
                    <lk-form-item label='签收时间:'>
                      <span>{{saleData.saleExpressReceipt.createTime | formatDate('YYYY-MM-DD HH:mm')}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='5' offset='1' v-if="saleData.saleExpress.deliveryMethod === 2">
                    <lk-form-item label='运费:'>
                      <span>{{saleData.saleExpress.freight || ''}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='6' offset='1'>
                    <lk-form-item label='签收单:'>
                      <span v-if="saleData.saleExpressReceipt && saleData.saleExpressReceipt.imgUrls && saleData.saleExpressReceipt.imgUrls.length > 0" style="color:#1890FF" @click="lookMoreImage">查看</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-form>
            </lk-card>
          </div>
        </div>
        <paymentModal
          v-model="showPayment"
          :orderInfo='orderInfo'
          :paidList='paidList'
          :update='false'
          @submitPay='handlePayment'
          :base='saleData'
          :receiveVerificationAmount='orderInfo.receiveVerificationAmount'
          :isCheckOrder='true'
        ></paymentModal>
        <section v-for="invoiceInfo in invoiceInfoList" :key="invoiceInfo.id">
          <div class="content">
          <lk-card title="开票信息">
            <lk-form :label-width="90">
              <lk-row :gutter='16'>
                <lk-col span='7'>
                  <lk-form-item label="开票日期:">
                    <span>{{invoiceInfo.invoiceDate}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span='7'>
                  <lk-form-item label="发票金额:">
                    <span>{{invoiceInfo.amount}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span='7'>
                  <lk-form-item label="不含税金额:">
                    <span>{{invoiceInfo.amountWithoutTax}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter='16'>
                <lk-col span='7'>
                  <lk-form-item label="税额:">
                    <span>{{invoiceInfo.tax}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span='7'>
                  <lk-form-item label="状态:">
                    <span>{{invoiceInfo.status}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span='7'>
                  <lk-form-item label="发票号:">
                    <span>{{invoiceInfo.code}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter='16'>
                <lk-col span='23'>
                  <lk-form-item label="销售订单号:">
                    <span>{{invoiceInfo.saleCode}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter='16'>
                <lk-col span='23'>
                  <lk-form-item label="发票明细:">
                    <div class="goodsTable">
                      <table>
                        <thead>
                          <tr>
                            <td>通用名</td>
                            <td>规格</td>
                            <td>包装单位</td>
                            <td>销售实价</td>
                            <td>数量</td>
                            <td>含税金额</td>
                            <td>税率</td>
                            <td>不含税金额</td>
                            <td>税额</td>
                            <td>是否DTP</td>
                          </tr>
                        </thead>
                        <tbody v-if='invoiceInfo.subData && invoiceInfo.subData.length'>
                          <template v-for="detail in invoiceInfo.subData">
                            <tr :key="detail.goodsInfoVoGoodsStoreId" :class="detail.inOrder === 1 ? 'inOrderClass':''">
                              <td>{{detail.goodsInfoVoApprovedDrugName}}</td>
                              <td>{{detail.goodsInfoVoSpec}}</td>
                              <td>{{detail.goodsInfoVoDrugMiniPackageUnitString}}</td>
                              <td>{{detail.financeInvoiceDetailPrice}}</td>
                              <td>{{detail.financeInvoiceDetailNum}}</td>
                              <td>{{detail.financeInvoiceDetailAmount}}</td>
                              <td>{{detail.financeInvoiceDetailOutputTaxRate}}</td>
                              <td>{{detail.financeInvoiceDetailAmountWithoutTax}}</td>
                              <td>{{detail.financeInvoiceDetailTotalTax}}</td>
                              <td>{{detail.isDtp}}</td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </div>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-form>
          </lk-card>
          </div>
        </section>

      </div>
    </BaseFrame>
    <lk-modal v-model="isShowReorder" title='重下运单' :mask-closable="false" :footer-hide="true">
      <div v-if='!hasSearchFreight'>
        <lk-form ref="reorderModal" :model="reorderModal" :rules="reorderModalRules" :label-width="100">
          <lk-form-item prop='name' label="收货人姓名：">
            <lk-input v-model="reorderModal.name" placeholder="请输入" :maxlength="30"></lk-input>
          </lk-form-item>
          <lk-form-item prop='regionList' label="收货城市：">
            <location v-model="reorderModal.regionList"></location>
          </lk-form-item>
          <lk-form-item prop='phone' label="收货人联系方式：">
            <lk-input v-model="reorderModal.phone" placeholder="请输入"></lk-input>
          </lk-form-item>
          <lk-form-item prop='address' label="收货详细地址：">
            <lk-input v-model="reorderModal.address" placeholder="请输入" :maxlength="200"></lk-input>
          </lk-form-item>
          <lk-form-item label="是否保险：" v-if="isSFColdChain">
            <div class="isInsurance-conent">
              <lk-switch v-model="reorderModal.isInsurance" style="width: 70px">
                <lk-icon type="md-checkmark" slot="open"></lk-icon>
                <lk-icon type="md-close" slot="close"></lk-icon>
              </lk-switch>
              <div class="isInsurance-tip">开启后将自动购买配送保险,由顺丰赔偿可能的超温、损坏和丢失,需额外支付订单金额0.028%的运费</div>
            </div>
          </lk-form-item>
        </lk-form>
        <div class="btnArea">
          <lk-button type="primary" style="margin-right:16px;" @click="toSearchFreight" :loading="searchFreightLoading">查询运费</lk-button>
          <lk-button @click="isShowReorder=false">取消</lk-button>
        </div>
      </div>
      <div v-else-if="hasSearchFreight">
        <lk-form ref="reorderModal" :model="reorderModal" :rules="reorderModalRules" :label-width="100">
          <lk-form-item prop='' label="配送渠道：">
            <lk-select v-model="reorderModal.deliverChannel" @on-change="handleChange">
              <lk-option :disabled="true" value="transport">
                <div style="display:flex;">
                  <div v-for="item in titleList" :key="item.id" style="width:33%;">{{item.title}}</div>
                </div>
              </lk-option>
              <lk-option
                v-for="item in deliveryChanelList"
                :value="item.transportSystemCode"
                :label="item.transportDesc"
                :key="item.transportSystemCode"
              >
                <div style="display:flex;">
                  <div style="width:33%;">{{item.transportDesc}}</div>
                  <div style="width:33%;">{{item.totalPrice}}</div>
                  <div style="width:33%;">{{item.deliverTime}}</div>
                </div>
              </lk-option>
            </lk-select>
          </lk-form-item>
          <lk-form-item prop='' label="运费：">
            <div>{{reorderModal.freight}}</div>
          </lk-form-item>
          <lk-form-item prop='' label="预计送达时间：">
            <div>{{reorderModal.arriveTimeStr}}</div>
          </lk-form-item>
        </lk-form>
        <div class="btnArea">
          <lk-button type="primary" style="margin-right:16px;" @click="confirmPlaceOrder" :loading="retryOrderLoading">确认下单</lk-button>
          <lk-button @click="toCancel">取消</lk-button>
        </div>
      </div>
    </lk-modal>
    <lk-modal
      v-model="searchConfig.showModal"
      :title='searchConfig.modalTitle'
      :mask-closable="false"
      :footer-hide="true"
    >
    <div style="maxHeight: 600px; overflow: scroll">
      <lk-table
        v-if="searchConfig.modalContent === ''"
        :data='searchConfig.tableData' border :columns="searchConfig.tableColumns"
      ></lk-table>
      <div v-else style="height: 110px; padding: 10px 20px">
        {{searchConfig.modalContent}}
      </div>
    </div>
    </lk-modal>
     <BarcodeModal
      v-if="barcodeData.orderNo"
      v-model='showBarcode'
      :barcodeData='barcodeData'
      @success="getDetail"
      ref="barcodeModal"
    ></BarcodeModal>
    <POSModal
      v-model="showDTPModal"
      :content="POSModalContent"
      content_title="未完成浦发POS收款的订单数超限,无法新建订单"
      @handleCancel='showDTPModal=false'
      type="alert"
      :noCancel='true'
      :showCountDown='false'
      @confirm='showDTPModal=false'
      confirmText='知道了'
    ></POSModal>
    <lk-modal title="图片详情" v-model="showPhoto" width='50%'  :closable='false'>
      <div class="detailContainer">
        <img :src="currentImg?decodeURIComponent(currentImg) :''" alt="" :style='{width:"100%"}' >
      </div>
      <lk-Page id="photoPage" :current.sync="currentPage" :page-size="1" :total="imageList.length" simple @on-change="changePage"  class="image-page"/>
    </lk-modal>
    <lk-modal
      v-model="editInfo"
      title="更新预约信息"
      :width="450"
      :mask-closable='false'
      @on-cancel="handleCancelSelection"
      >
      <div class="uploadContainer">
        <div style="display:flex">
          <span style="margin-top:8px;margin-left: 30px; font-size: 12px;">是否线下预约：</span>
          <lk-radio-group v-model.trim="isOffLine" style="margin-top:6px" @on-change='clickEpSourceType'>
            <lk-radio :label="1" :value="1" >是</lk-radio>
            <lk-radio :label="2" :value="2" >否</lk-radio>
          </lk-radio-group>
        </div>
        <div style="display:flex">
          <span style="color: red;margin-top:20px;margin-left: 26px;margin-right: 3px;">*</span>
          <span style="margin-top:18px; font-size: 12px;">线下预约单号：</span>
          <lk-input style="width: 250px; margin-top:10px" width :maxlength='100' :disabled='isOffLine===2' placeholder='请输入' v-model.trim="externalOrderNo"></lk-input>
        </div>
      </div>
      <div class="modalFooter" slot="footer">
          <span style="font-size: 1px; color: red; display: inline-block; margin-right: 170px;">只支持更新7日内创建的销售订单</span><lk-button type='primary' @click='toSaveEdit'>更新</lk-button>
      </div>
    </lk-modal>
  </div>
</template>
<script>
// import moment from 'moment';
import BaseFrame from '../../components/frame/BaseFrame.vue';
import PaymentModal from '../../components/sale/PaymentModal.vue';
import prescriptionCommon from '../../components/prescription/Common.vue';
import prescriptionDecoction from '../../components/prescription/Decoction.vue';
import DiscountInformation from '../../components/sale/DiscountInformation.vue';
import timeStampDatePicker from '../../components/timeStampDatePicker.vue';
import CredentialsInput from '../../components/CredentialsInput';
import sale from '../../services/sale';
import utils from '../../libs/utils';
import Uploader from '../../components/Uploader.vue';
import location from '../../components/location.vue';
import sf from '../../services/sf';
import BarcodeModal from '../../components/BarcodeModal.vue';
import POSModal from '../../components/POSModal.vue';
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'OrderCheck',
  mixins: [queryMixins],
  components: {
    BaseFrame,
    prescriptionCommon,
    prescriptionDecoction,
    PaymentModal,
    DiscountInformation,
    timeStampDatePicker,
    CredentialsInput,
    Uploader,
    location,
    BarcodeModal,
    POSModal,
  },

  computed: {
    depositCol() {
      const columnsCommon = utils.deepClone(this.financeCommonCol);
      columnsCommon.splice(3, 0, {
        title: '预收核销', key: 'depositVerificationAmount', minWidth: 116,
      });
      return [{
        title: '预收款编码', key: 'depositCode', minWidth: 116,
      }, ...columnsCommon,
      ];
    },
    receiveCol() {
      const columnsCommon = utils.deepClone(this.financeCommonCol);
      columnsCommon.splice(3, 0, {
        title: '应收核销', key: 'receiveVerificationAmount', minWidth: 116,
      });
      return [{
        title: '应收款编码', key: 'depositCode', minWidth: 116,
      }, ...columnsCommon];
    },
    showCollection() {
      return this.saleData.saleOrder.status === 1 && this.saleData.saleOrder.ableToProceeds && this.saleData.saleOrder.deliveryMethod !== 2;
    },
    submitText() {
      if (this.isColdChain) {
        return '提交';
      } if (this.showCollection) {
        return '收款';
      }
      return '';
    },
    modelData() {
      const result = this.saleData.saleOrderDetailList;
      result.forEach((item) => {
        item.rex = item.realPrice * item.goodsCount * item.outputTaxRate;
      });
      return result;
    },
    orderGoodsCount() {
      let count = 0;
      this.saleData.saleOrderDetailList.forEach((item) => {
        count += item.goodsCount;
      });
      return count.toFixed(2);
    },
    userStr() {
      if (this.saleData.purchaseType === 2) {
        return '领用者';
      }
      return '购买者';
    },
    logisticsBtnText() {
      const saleExpress = this.saleData.saleExpress;
      // 顺丰查询物流
      if (saleExpress && [2].includes(this.saleData.saleExpress.deliveryMethod)) {
        return '物流查询';
      }
      return '';
    },
    isSFColdChain() {
      // 顺丰并且冷链
      if (this.saleData && this.saleData.saleOrderDetailVoList && this.saleData.saleExpress) {
        const ifColdChain = this.saleData.saleOrderDetailVoList.some(item => item.isColdChain === 1);
        const isSF = [2].includes(this.saleData.saleExpress.deliveryMethod);
        return ifColdChain && isSF;
      }
      return false;
    },
    coldChainBtnText() {
      if (this.isSFColdChain) {
        return '冷链查询';
      }
      return '';
    },
    SfOrderStatusTxt() { // 通过判断订单是否是顺丰医药，是的话需要显示取消订单按钮，通过后端返回订单状态判断订单是否已经取消，取消后的支持重下订单
      if (this.saleData.saleOrder && this.saleData.saleOrder.status === 4) { // 已取消的销售订单不支持取消运单和重下运单
        return '';
      }
      const saleExpress = this.saleData.saleExpress;
      if (saleExpress && saleExpress.received === 2) { // 如果是已收货，不展示按钮
        return '';
      }
      if (saleExpress && saleExpress.deliveryMethod === 2) {
        if (this.hasCancelSfOrder) {
          return '重下运单';
        }
        return '取消运单';
      }
      return '';
    },
    editCode() {
      if ((this.isSuperRole() || (this.isAllowUpdateExternal === 1 && this.handlePermission('allowUpdateExternal'))) && (this.epSourceType == 0 || this.epSourceType == 11)) {
        return '更新预约信息';
      }
      return '';
    },
  },
  watch: {

  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请填写联系方式'));
      } else {
        const phone = [/^1[3465789]\d{9}$/, /^0\d{2,3}-?\d{7,8}$/, /^0\d{2,3}\s?\d{7,8}$/];
        let ifsuccess = false;
        phone.forEach((item, index) => {
          if (item.test(value)) {
            ifsuccess = true;
          }
        });
        ifsuccess ? callback() : callback(new Error('请输入手机号码或包含区号的固定电话号码'));
      }
    };
    return {
      epSourceType: 0,
      tempExternalOrderNo: '',
      externalOrderNo: '',
      isOffLine: 1,
      isAllowUpdateExternal: 2,
      editInfo: false,
      currentPage: 1,
      currentImg: '',
      imageList: [],
      showPhoto: false,
      searchConfig: {
        showModal: false,
        modalTitle: '查询',
        tableColumns: [],
        tableData: [],
        modalContent: '',
      },
      logisticsColumns: [ // 物流查询
        { title: '状态', key: 'routeCodeName', minWidth: 116 },
        { title: '时间', key: 'routeTime', minWidth: 116 },
        { title: '说明', key: 'routeDesc', minWidth: 256 },
      ],
      coldChainColumns: [ // 冷链查询
        { title: '时间', key: 'recordTime', minWidth: 160 },
        { title: '状态', key: 'opCodeName', minWidth: 160 },
        { title: '温度', key: 'recordValue', minWidth: 160 },
      ],
      POSModalContent: '', // POSModal组件展示内容
      showDTPModal: false, // POSModal组件是否显示
      showBarcode: false,
      barcodeData: {},
      titleList: [
        {
          id: 1,
          title: '配送渠道',
        },
        {
          id: 2,
          title: '运费',
        },
        {
          id: 3,
          title: '预计送达时间',
        },
      ],
      reorderModal: {
        regionList: [],
        name: '',
        phone: '',
        address: '',
        deliverChannel: null,
        freight: '',
        arriveTimeStr: '',
        isInsurance: false,
      },
      reorderModalRules: {
        name: [
          { required: true, message: '请填写收货人姓名', trigger: 'change'}
        ],
        regionList: [
          { required: true, message: '请选择收货城市', trigger: 'change', type: 'array'}
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'change'}
        ],
        address: [
          { required: true, message: '请填写收货详细地址', trigger: 'change'}
        ],
      },
      searchFreightLoading: false,
      retryOrderLoading: false,
      deliveryChanelList: [], // 存放配送渠道
      hasSearchFreight: false, // 是否查询运费成功
      isShowReorder: false, // 是否显示重下运单弹窗
      hasCancelSfOrder: false, // 是否已取消顺丰订单,false否，true是
      depositData: [],
      receiveData: [],
      promoteDiscountVOList: [], // 折扣信息
      financeCommonCol: [
        { title: '收款方日期', key: 'proceedsTime', minWidth: 116 },
        { title: '收款方式', key: 'proceedsTypeName', minWidth: 116 },
        { title: '收款金额', key: 'proceedsAmount', minWidth: 116 },
        { title: '付款人', key: 'paymentUserName', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
      ],
      isColdChain: false,
      paidList: [],
      code: '',
      showPayment: false,
      saleUsageList: [],
      paymentList: [],
      orderInfo: {},
      toPaymentList: [],
      infos: [],
      subInfosArr: [],
      typeList: ['', '店面购买', '配送', '预定'],
      deliveryMethodList: ['自配送', '顺丰医药', '其他', '菜鸟-顺丰'],
      genderList: ['', '男', '女'],
      saleBuyerInfo: {
        buyerIdCard: [

          {
            validator: utils.validate.IDValidator,
            trigger: 'blur',
          },
        ],
      },
      addGoods: false,
      current: 0,
      loginPrescription: false,

      goodsColumns: [{
        type: 'index',
        title: '行号',
        minWidth: 116,
      },

      {
        title: '商品编码',
        key: 'drugSerialCode',
        minWidth: 116,
      },
      {
        title: '商品通用名称',
        key: 'approvedDrugNames',
        minWidth: 116,
      },
      {
        title: '规格',
        key: 'specifications',
        minWidth: 116,
      },
      {
        title: '批准文号',
        key: 'approvalCode',
        minWidth: 116,
      },
      {
        title: '产地',
        key: 'origin',
        minWidth: 116,
      },
      {
        title: '医保编码',
        key: 'medListCodg',
        width: 200,
      },
      {
        title: '销售价格',
        key: 'retailPrice',
        minWidth: 116,
      },
      {
        title: '剂型',
        key: 'dosageForm',
        minWidth: 116,
      },
      {
        title: '单位',
        key: 'goodsUnit',
        minWidth: 116,
      },
      {
        title: '数量',
        key: 'goodsCount',
        minWidth: 116,
      },
      {
        title: '产品追溯码',
        key: 'traceCode',
        minWidth: 116,
      },
      {
        title: 'UDI码',
        key: 'udiCode',
        tooltip: true,
        minWidth: 116,
      },
      {
        title: '批号',
        key: 'goodsLot',
        minWidth: 116,
      },
      {
        title: '实售单价',
        key: 'realPrice',
        minWidth: 116,
      },
      {
        title: '助记码',
        key: 'mnemonicCode',
        minWidth: 116,
      }, // 确认字段名
      {
        title: '仓库',
        key: 'storehouseName',
        minWidth: 116,
      },
      {
        title: '货位',
        key: 'allocationName',
        minWidth: 116,
      },
      {
        title: '批次',
        key: 'goodsBatch',
        minWidth: 116,
      },
      {
        title: '供应商',
        key: 'supplierName',
        minWidth: 116,
      },
      {
        title: '生产企业',
        key: 'manufacturer',
        minWidth: 116,
      },
      {
        title: '上市许可持有人',
        key: 'mah',
        minWidth: 118,
      },
      ],
      goodsCount: 0,
      goodsPage: 1,
      goodsSize: 10,
      saleExpress: {
        transStartTime: [{ required: true, message: '请填写起运时间', type: 'number' }],
        transEndTime: [{ required: true, message: '请填写送达时间', type: 'number' }],
      },
      goodsData: [],
      orderId: '',
      payData: {
        id: '', // 订单ID,
        type: '',

      },

      diseaseList: [],
      saleData: {
        saleOrder: {},
        saleOrderDetailList: [],
        saleExpress: {
          transStartTime: '',
          transEndTime: '',
        },
        salePrescription: {
          prescriptionNo: '',
          patientName: '',
          patientGender: '',
          patientAge: '',
          prescriptionHospital: '',
          prescriptionDoctor: '',
          patientPhone: '',
          diseaseId: '',
          diseaseName: '',
          additionalRemark: '',
          allocater: '',
          allocaterName: '',
          reviewer: '',
          reviewerName: '',
          createUser: '',
          createUserName: '',
        },
        listSaleUsage: [],
        financeInvoiceVoList: [],
      },
      totalPayment: 0,
      noSame: false,
      invoiceInfoList: [],
      tempobj: {},
    };
  },
  filters: {
    handleComputed(val) {
      val += '';
      return val.slice(0, val.indexOf('.') + 3);
    },
  },

  methods: {
    handleEditCode() {
      this.editInfo = true;
    },
    clickEpSourceType(e) {
      if (e == 1) {
        this.externalOrderNo = this.tempExternalOrderNo;
      } else {
        this.externalOrderNo = '';
      }
    },
    toSaveEdit() {
      if (this.isOffLine == 1) {
        if (!this.externalOrderNo) {
          this.$Message.error('请填写线下预约单号');
          return;
        }
      }
      this.updateOrderInfo();
    },
    handleCancelSelection() {
      this.editInfo = false;
    },
    lookMoreImage() {
      this.showPhoto = true;
      this.currentPage = 1;
      this.currentImg = this.imageList[0];
      document.querySelector('#photoPage').childNodes[1].childNodes[0].disabled = 'true';
    },
    changePage(e) {
      this.currentImg = this.imageList[e - 1];
    },
    handleLogisticsClick() {
      this.searchConfig.modalContent = '';
      const params = {
        orderId: this.$route.params.id,
      };
      sale.getListLogistics(params).then((res) => {
        if (res.data.status === 200) {
          this.searchConfig.tableColumns = this.logisticsColumns;
          this.searchConfig.tableData = res.data.data;
          this.searchConfig.modalTitle = '物流查询';
          this.searchConfig.showModal = true;
        } else {
          this.$Message.error('物流查询失败，请稍后重试');
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleColdChainClick() {
      this.searchConfig.modalContent = '';
      const params = {
        orderId: this.$route.params.id,
        storeId: this.$store.state.storeInfo.id,
      };
      sale.getSFlistTemperatures(params).then((res) => {
        if (res.data.status === 200) {
          let result = [];
          if (res.data.data && res.data.data.length) {
            result = res.data.data.map((item) => {
              item.recordTime = utils.formatDateToSecond(item.recordTime);
              return item;
            });
          }
          if (result && result.length && result.length === 1) {
            const {
              recordValue,
              recordTime,
            } = result[0];
            this.searchConfig.modalContent = `订单配送中，当前（${recordTime}）温度为${recordValue}℃，完整温度跟踪信息需待运单签收后查询`;
          }
          this.searchConfig.tableColumns = this.coldChainColumns;
          this.searchConfig.tableData = result;
          this.searchConfig.modalTitle = '冷链查询';
          this.searchConfig.showModal = true;
        } else {
          this.$Message.error('冷链查询失败，请稍后重试');
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    toCancel() {
      this.isShowReorder = false;
      this.hasSearchFreight = false;
    },
    handleChange(val) {
      const obj = this.deliveryChanelList.find(item => item.transportSystemCode === val);
      this.tempobj = utils.deepClone(obj);
      this.reorderModal.freight = obj.totalPrice;
      this.reorderModal.arriveTimeStr = obj.deliverTime;
    },
    handleInvoiceData() {
      this.saleData.financeInvoiceVoList.forEach((item) => {
        if (item.financeInvoice) {
          item.id = item.financeInvoice.id;
          item.storeName = item.financeInvoice.storeName;
          item.invoiceDate = utils.exchangeTime(item.financeInvoice.invoiceDate);
          item.amount = item.financeInvoice.amount;
          item.amountWithoutTax = item.financeInvoice.amountWithoutTax;
          item.tax = item.financeInvoice.tax;
          item.code = item.financeInvoice.code;
          item.saleCode = '';
          item.subData = [];
        }
        if (item.financeInvoice.status === 2) {
          item.status = '已完结';
        } else {
          item.status = '未完结';
        }
        if (item.financeInvoiceDetailVoList) {
          item.financeInvoiceDetailVoList.forEach((detail) => {
            const resultItem = {};
            utils.exchangeTable(detail, resultItem);
            if (resultItem.goodsInfoVoIsDtp === 1) {
              resultItem.isDtp = '是';
            } else if (resultItem.goodsInfoVoIsDtp === 2) {
              resultItem.isDtp = '否';
            }
            item.subData.push(resultItem);
            if (item.saleCode) {
              item.saleCode = `${item.saleCode},${detail.financeInvoiceDetail.referCode}`;
            } else {
              item.saleCode = detail.financeInvoiceDetail.referCode;
            }
          });
        }
        this.invoiceInfoList.push(item);
      });
    },
    handleSubmit() {
      if (this.isColdChain) {
        this.$refs.saleExpress.validate((valid) => {
          const temp = utils.deepClone(this.saleData);
          let listTest = true;
          temp.saleOrderDetailVoList = temp.saleOrderDetailList.map((item) => {
            if (item.isColdChain === 1 && ((item.temperatureStart === '') || (item.temperatureEnd === ''))) {
              listTest = false;
            }


            return { saleOrderDetail: item };
          });


          if (!listTest) {
            this.$Message.error('请填写起运，送达温度');
            return;
          }
          if (temp.saleExpress.transEndTime < temp.saleExpress.transStartTime) {
            this.$Message.error('请填写正确运送时间');
            return;
          }
          if (valid) {
            // debugger;
            sale.updateColdChainOrder(temp).then((res) => {
              if (res.data.status === 200) {
                this.$Message.success('提交成功');
                this.$router.push({ name: 'salesOrderQuery' });
              } else {
                this.$Message.error(res.data.error);
              }
            }).catch((err) => {
              utils.handleError(err);
            });
          }
        });
      } else {
        this.showPayment = true;
      }
    },
    handlePayment(paymentList, infos, expressInfo, base, curPatientInfo, promotionInfo, receiveAmountList, specialCollection) {
      const tempPay = {};
      tempPay.saleOrder = {
        id: this.payData.id,
      };
      let totalReceiveAmount = 0;
      if (receiveAmountList instanceof Array && receiveAmountList.length) {
        receiveAmountList.forEach((item) => {
          if (item.depositVerificationAmount) {
            totalReceiveAmount += item.depositVerificationAmount * 1;
          }
        });
      }
      const paymentListCopyed = utils.deepClone(paymentList);
      paymentListCopyed.push({
        proceedsTypeId: 6,
        proceedsTypeName: '预收款',
        amount: totalReceiveAmount,
      });
      receiveAmountList.forEach((item) => {
        item.financeDepositId = item.id;
        item.amount = item.depositVerificationAmount;
      });
      tempPay.financeDepositOrderList = receiveAmountList;
      tempPay.saleOrderProceedsList = paymentListCopyed;
      tempPay.saleExpress = expressInfo;
      paymentListCopyed.forEach((item) => {
        if (item.financeDepositId && item.amount) {
          tempPay.financeDepositId = item.financeDepositId;
          tempPay.verificationDeposit = item.amount;
        }
      });
      let promoteDiscountVOList = utils.deepClone(promotionInfo.promoteDiscountVOList);
      if (promotionInfo.promotionDiscount) {
        const { promotionDiscount, promotionReason} = promotionInfo;
        const promotionItem = {
          cutPrice: promotionDiscount,
          remark: promotionReason,
        };
        promoteDiscountVOList.push(promotionItem);
      }
      // 如果有pos收款，入参增加tag=2；
      if (specialCollection && specialCollection.SPDBAmountList.amount) {
        tempPay.saleOrder.tag = 2;
        tempPay.saleOrder.receivablesAmount = specialCollection.SPDBAmountList.amount;
      }
      const {
        totalAmount,
        discount,
      } = base.saleOrder;
      tempPay.saleOrder.totalAmount = totalAmount;
      tempPay.saleOrder.discount = discount;

      tempPay.discount = infos.discount;
      tempPay.promoteDiscountVOList = promoteDiscountVOList;
      sale.payOrder(tempPay).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('收款成功！');
          this.showPayment = false;
          this.getDetail('collection');
        } else if (res.data.status === 80000) {
          this.showDTPModal = true;
          this.POSModalContent = res.data.error;
          this.showPayment = false;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    validateOrderInfo() {
      return new Promise((resolve) => {
        this.$refs.reorderModal.validate((valid) => {
          resolve(valid);
        });
      });
    },
    confirmPlaceOrder() {
      if (!this.reorderModal.deliverChannel) {
        this.$Message.error('请先填写完整信息');
        return;
      }
      this.retryOrderLoading = true;
      const param = {
        orderId: this.$route.params.id,
        name: this.reorderModal.name,
        phone: this.reorderModal.phone,
        provinceId: this.reorderModal.regionList[0],
        cityId: this.reorderModal.regionList[1],
        countyId: this.reorderModal.regionList[2],
        address: this.reorderModal.address,
        freight: this.reorderModal.freight,
        deliveryChannel: this.reorderModal.deliverChannel,
        deliveryChannelName: this.tempobj.transportDesc,
        deliveryTime: this.reorderModal.arriveTimeStr,
        isInsurance: this.reorderModal.isInsurance ? 1 : 0,
        orderTotalAmount: Number(this.payData.totalAmount || 0),
      };
      sf.retryCreateOrder(param).then((res) => {
        this.retryOrderLoading = false;
        if (res.data.status === 200) {
          this.$Message.success('重新下单成功');
          this.isShowReorder = false;
          this.getDetail();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.retryOrderLoading = false;
        utils.handleError(err);
      });
    },
    async toSearchFreight() {
      const result = await this.validateOrderInfo();
      const saleExpress = this.saleData.saleExpress;
      if (result) {
        const srcAddress = {
          regionList: saleExpress.consignIdList || [],
          address: saleExpress.consignAddress || '',
          name: saleExpress.consignorName || '',
          phone: saleExpress.consignorPhone || '',
        };
        const destAddress = {
          regionList: this.reorderModal.regionList,
          address: this.reorderModal.address || '',
          name: this.reorderModal.name || '',
          phone: this.reorderModal.phone || '',
        };
        const goodsDetail = [];
        this.saleData.saleOrderDetailList.forEach((item) => {
          goodsDetail.push({
            goodsStoreId: item.goodsStoreId,
            goodsCount: item.goodsCount,
          });
        });
        const ifColdChain = this.saleData.saleOrderDetailVoList.find(item => item.isColdChain === 1);
        this.searchFreightLoading = true;
        const params = {
          srcAddress,
          destAddress,
          goodsDetail,
          orderTotalAmount: Number(this.payData.totalAmount || 0),
          isInsurance: this.reorderModal.isInsurance ? 1 : 0,
          isColdChain: ifColdChain ? 1 : 2,
        };
        sf.getExpressFee(params).then((res) => {
          this.searchFreightLoading = false;
          if (res.data.status === 200) {
            if (res.data.data.list && res.data.data.list.length) {
              this.hasSearchFreight = true;
              this.deliveryChanelList = res.data.data.list;
              this.$Message.success('查询成功');
              return;
            }
            this.$Message.error('没有可用的配送渠道');
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          this.searchFreightLoading = false;
          utils.handleError(err);
        });
      }
    },
    handleClick() {
      if (this.hasCancelSfOrder) { // 已经取消运单
        const saleExpress = this.saleData.saleExpress;
        if (saleExpress) {
          this.reorderModal.name = saleExpress.name || '';
          this.reorderModal.phone = saleExpress.phone || '';
          this.reorderModal.address = saleExpress.address || '';
          this.reorderModal.regionList = [saleExpress.provinceId, saleExpress.cityId, saleExpress.countyId];
        }
        this.isShowReorder = true;
      } else {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>是否确认取消运单?</p>',
          onOk: () => {
            const params = {
              orderId: this.$route.params.id,
              operateType: 1, // 根据后端要求传固定值1
            };
            sale.toCancelSfMedicineOrder(params).then((res) => {
              if (res.data.status === 200) {
                this.$Message.success('取消成功');
                this.getDetail();
              } else {
                this.$Message.error(res.data.error);
              }
            }).catch((err) => {
              utils.handleError(err);
            });
          }
        });
      }
    },
    getDiseaseList() {
      return new Promise((resolve) => {
        sale.getDiseaseInfo().then((res) => {
          if (res.data.status === 200) {
            this.diseaseList = res.data.data;
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    updateOrderInfo() {
      const tempData = { orderId: this.$route.params.id, isOffLine: this.isOffLine, externalOrderNo: this.externalOrderNo };
      sale.updateOrderInfo(tempData).then((res) => {
        if (res.data.status === 200) {
          this.requestDetail();
          this.editInfo = false;
          this.$Message.success('更新成功');
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getDetail(type) {
      sale.getOrderAllById({
        id: this.$route.params.id,
      }).then((res) => {
        if (res.data.status === 200) {
          const {
            orderNo,
            id,
            tag,
            proceedsStatus,
            externalOrderNo,
            epSourceType,
          } = res.data.data.saleOrder;
          this.epSourceType = epSourceType;
          this.isOffLine = epSourceType === 11 ? 1 : 2;
          this.externalOrderNo = externalOrderNo;
          this.tempExternalOrderNo = externalOrderNo;
          this.isAllowUpdateExternal = res.data.data.allowUpdateExternal;
          // 如果是收款完成之后查询的订单信息，tag为2，并且未收完款的时候显示浦发pos二维码
          if (type === 'collection' && tag === 2 && proceedsStatus !== 1) {
            this.barcodeData = {
              id,
              orderNo,
            };
            this.showBarcode = true;
          }
          this.promoteDiscountVOList = [];
          const temp = res.data.data;
          this.hasCancelSfOrder = temp.hasCancelSfOrder || false;
          this.promoteDiscountVOList = res.data.data.promoteDiscountVOList || [];
          temp.retailType === 3 && (this.goodsColumns.splice(6, 1));
          this.code = temp.saleOrder.orderNo;
          this.receiveData = [];
          this.depositData = [];
          if (temp.receiveFinanceDepositList && temp.receiveFinanceDepositList.length) {
            temp.receiveFinanceDepositList.forEach((item) => {
              item.proceedsTime = utils.formatTime(item.proceedsTime);
              item.createTime = utils.formatTime(item.createTime);
              this.receiveData.push(item);
            });
          }
          if (temp.depositFinanceDepositList && temp.depositFinanceDepositList.length) {
            this.depositData = utils.deepClone(temp.depositFinanceDepositList);
            this.depositData.forEach((item) => {
              item.proceedsTime = utils.formatTime(item.proceedsTime);
              item.createTime = utils.formatTime(item.createTime);
            });
            temp.saleOrderProceedsList.forEach((item) => {
              item.financeDepositId = temp.depositFinanceDepositList[0].id;
            });
          }
          this.infos = [{
            name: '营业员:',
            value: temp.saleOrder.createUserName,
          },
          {
            name: '创建时间:',
            value: utils.exchangeTimeToSecond(temp.saleOrder.createTime),
          },
          // {
          //   name: '订单来源:',
          //   value: temp.saleOrder.epSourceTypeName,
          // },
          {
            name: 'ID类型:',
            value: temp.saleOrder.epCreatorTypeName,
          },
          {
            name: '来源姓名:',
            value: temp.saleOrder.epCreator,
          },
          {
            name: '来源ID:',
            value: temp.saleOrder.epCreatorId,
          },
          ]; // temp.saleOrder;
          this.subInfosArr = [
            {
              name: '日报编号',
              value: temp.proceedsCode || '',
            },
          ];
          temp.saleOrderDetailList.forEach((item, index) => {
            item.mah = temp.saleOrderDetailVoList[index].mah;
            item.isColdChain = temp.saleOrderDetailVoList[index].isColdChain;
          });
          if (!this.isColdChain && temp.saleOrderDetailVoList.filter(item => item.isColdChain === 1).length) {
            this.goodsColumns = this.goodsColumns.concat([
              {
                title: '起运温度',
                key: 'temperatureStart',

                minWidth: 116,

              },
              {
                title: '送达温度',
                key: 'temperatureEnd',

                minWidth: 116,

              },
            ]);
          }
          this.saleData.retailType = res.data.data.retailType;

          // 修复赋值无法触发computed 问题
          // this.saleData.saleOrderDetailVoList = temp.saleOrderDetailVoList || [];
          this.$set(this.saleData, 'saleOrderDetailVoList', temp.saleOrderDetailVoList || []);

          this.saleData.saleExpressReceipt = res.data.data.saleExpressReceipt || {};
          if (temp.saleExpressReceipt) {
            this.imageList = temp.saleExpressReceipt.imgUrls || [];
          } else {
            this.imageList = [];
          }
          this.saleData.purchaseType = res.data.data.purchaseType;
          if (temp.saleOrderDetailList && temp.saleOrderDetailList.length) {
            this.saleData.saleOrderDetailList = temp.saleOrderDetailList;
          }
          this.orderInfo = {
            payment: temp.saleOrder.amountWithoutDiscount !== null ? temp.saleOrder.amountWithoutDiscount : temp.saleOrder.totalAmount,
            totalAmount: temp.saleOrder.totalAmount,
            discount: temp.saleOrder.discount || 0,
            goodsCount: temp.saleOrder.totalGoodsNum,
            saleExpress: temp.saleExpress,
            notOrigin: !temp.saleOrder.epId,
            insuranceId: temp.saleOrder.insuranceId,
            type: temp.orderType,
            switchStatus: temp.saleOrder.showPatientFlag,
            patientName: temp.saleOrder.relatePatientName || '',
            patientPhone: temp.saleOrder.originalPatientPhone || '',
            sourceType: temp.saleOrder.epSourceType || 0,
            receiveVerificationAmount: temp.saleOrder.receiveVerificationAmount,
            receiveFinanceDepositList: temp.receiveFinanceDepositList,
            promoteDiscountVOList: this.promoteDiscountVOList,
            receiveAmountList: temp.depositFinanceDepositList || [],
            completePOSCollection: temp.saleOrder.tag === 2 && temp.saleOrder.proceedsStatus === 1, // 是否完成pos收款
            tag: temp.saleOrder.tag || '',
            receivablesAmount: temp.saleOrder.receivablesAmount || 0, // 如果完成pos收款此值就代表pos收款金额
            hideTopInfo: true,
          };
          this.paidList = temp.saleOrderProceedsList;
          if (temp.depositFinanceDepositList) {
            this.paidList.forEach((item) => {
              item.financeDepositId = temp.depositFinanceDepositList[0].id;
              item.financeDeposit = temp.depositFinanceDepositList[0];
            });
          }
          this.paymentList = temp.saleOrderProceedsList;
          temp.realCashProceeds && this.paymentList.unshift(temp.realCashProceeds);
          if (temp.financeInvoiceVoList) {
            this.saleData.financeInvoiceVoList = temp.financeInvoiceVoList;
            this.handleInvoiceData();
          } else {
            delete this.saleData.financeInvoiceVoList;
          }
          if (temp.salePrescription) {
            this.saleData.salePrescription = temp.salePrescription;

            const { provinceId, cityId, countyId } = temp.salePrescription;
            this.saleData.salePrescription.locationArr = [
              provinceId, cityId, countyId,
            ];
            const { provinceName, cityName, countyName } = temp.salePrescription;
            this.saleData.salePrescription.locationString = countyName ? `${provinceName}/${cityName}/${countyName}` : '';
          } else {
            delete this.saleData.salePrescription;
          }
          if (temp.saleUsageList && temp.saleUsageList.length) {
            const list = utils.mergeSameDrugs(temp.saleUsageList, 'goodsStoreId', 'goodsCount');
            this.saleUsageList = list;
            this.saleData.salePrescription.saleUsageList = list;
          }
          temp.saleBuyerInfo && (this.saleData.saleBuyerInfo = temp.saleBuyerInfo);
          temp.saleExpress && (this.saleData.saleExpress = temp.saleExpress);
          // if (temp.saleExpress) {
          //   this.saleData.saleExpress = temp.saleExpress;
          // }
          this.saleData.hasRX = false;
          this.saleData.hasEphedrine = false;
          this.saleData.saleOrderDetailList.forEach((val) => {
            if (val.isRX === 1) {
              this.saleData.hasRX = true;
            }
            if (val.isEphedrine === 1) {
              this.saleData.hasEphedrine = true;
            }
          });
          if (temp.saleOrder) {
            this.saleData.saleOrder = temp.saleOrder;
            this.payData = Object.assign(this.payData, temp.saleOrder);
          }
          this.payData.totalAmount = temp.saleOrder.totalAmountDisplay;
          this.payData.realProceedsAmount = temp.realProceedsAmount;
          this.payData.changeAmount = utils.fixNumber(temp.proceedsAmount - temp
            .realProceedsAmount, 2);

          // 只有冷链进入才查询
          if (this.isColdChain) {
            this.$nextTick(() => {
              this.getColdChain();
            });
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // 默认带出时间，温度
    getColdChain() {
      const params = {
        orderId: this.$route.params.id,
        storeId: this.$store.state.storeInfo.id,
      };
      sale.getSFlistTemperatures(params).then((res) => {
        if (res.data.status === 200) {
          const result = res.data.data;
          if (result.length && result.length > 1) {
            const firstItem = result[0];
            const lastItem = result[result.length - 1];
            this.$set(this.saleData.saleExpress, 'transStartTime', firstItem.recordTime);
            this.$set(this.saleData.saleExpress, 'transEndTime', lastItem.recordTime);
            const saleOrderDetailList = utils.deepClone(this.saleData.saleOrderDetailList);
            this.saleData.saleOrderDetailList = saleOrderDetailList.map((item) => {
              item.temperatureStart = firstItem.recordValue;
              item.temperatureEnd = lastItem.recordValue;
              return item;
            });
            console.log(firstItem.recordTime, lastItem.recordTime, this.saleData.saleExpress);
          }
        } else {
          this.$Message.error('冷链查询失败，请稍后重试');
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    requestDetail() {
      if (this.$route.name === 'coldChainInfoEdit') {
        this.isColdChain = true;
        this.goodsColumns = this.goodsColumns.concat([
          {
            title: '起运温度',
            key: 'temperatureStart',
            fixed: 'right',
            minWidth: 116,
            render: (h, params) => h('NumberInput', {
              props: {
                value: params.row.temperatureStart,
                type: 'canMinus',
                disabled: params.row.isColdChain !== 1,
              },
              on: {
                'on-blur': (val) => {
                  console.log(val);
                  this.saleData.saleOrderDetailList[params.index].temperatureStart = val;
                },
              },
            }),
          },
          {
            title: '送达温度',
            key: 'temperatureEnd',
            fixed: 'right',
            minWidth: 116,
            render: (h, params) => h('NumberInput', {
              props: {
                type: 'canMinus',
                value: params.row.temperatureEnd,
                disabled: params.row.isColdChain !== 1,
              },
              on: {
                'on-blur': (val) => {
                  console.log(val);
                  this.saleData.saleOrderDetailList[params.index].temperatureEnd = val;
                },
              },
            }),
          },
        ]);
      }
      Promise.all([
        this.getDiseaseList(),
      ]).then(() => {
        this.getDetail();
      });
    },
    isSuperRole() {
      const currentRoleIds = [];
      this.$store.state.user.roles.forEach((item) => {
        currentRoleIds.push(item.id);
      });
      if (currentRoleIds.includes(17)) { // 系统管理员 超级管理员
        return true;
      }
      return false;
    },
  },
  created() {
    this.requestDetail();
  },
};

</script>
<style lang="less" scoped>
  .titleContainer {
    padding: 0 32px;
    background: #fff;
    height: 120px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    height: 67px;
    line-height: 67px
  }

  .step {
    width: 50%
  }

  .tableContainer,
  .content {
    padding: 16px;
    padding-bottom: 0px;
  }

  .btns {
    >* {
      margin-left: 16px
    }
  }

  .totalPay {
    font-size: 16px;
    color: #1890FF;
  }

  .addContainer {
    // width: 836px;
    height: 300px;
    margin-bottom: 14px
  }

  .goodsTable {
    table {
      width: 100%;
      border-collapse: collapse;

      tr {
        height: 46px
      }

      td {
        border: 1px solid #dedede;
        min-width: 10%;
        padding: 0 13px;

      }

      thead {
        background: #fafafa;
        font-weight: 500
      }
    }

    .detail {
      background: #F5F5F5;
      padding: 12px 24px;

      >td {
        padding-right: 0;

        >div {

          display: flex;
          flex-wrap: wrap
        }
      }

      .detailItem {
        margin-right: 30px
      }
    }
  }

  .modalQuery {
    display: flex;

    label {
      width: 60px;
      line-height: 32px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.75);
    }
  }

  .infos {
    .infosStr {
      >span {
        padding-right: 10px
      }
    }
  }

.goodsTable{
  // overflow: auto;
  // overflow-x: auto;
  // border: 1px solid #eee;
  table{
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #eee;

    tr{
      height: 46px
    }
    td{
      border: 1px solid #dedede;
      min-width: 100px;
      padding: 0 13px;

    }
    thead{
      background: #fafafa;
      font-weight: 500
      }
    }
    .detail{
      background: #F5F5F5;
      padding: 12px 24px;
      >td{
        padding-right: 0;
       >div{

         display: flex;
         flex-wrap: wrap
       }
      }
      .detailItem{
        margin-right: 30px
      }
    }
}
.inOrderClass{
  color: #2d8cf0;
}
.btnArea {
  display: flex;
  justify-content: flex-end;
}
.isInsurance-conent {
    display: flex;
    align-items: center;
    .isInsurance-tip {
      margin-left: 10px;
      line-height: initial;
    }
  }
  .image-page {
    margin-top: 10px;
    display: flex;
   justify-content: center;
  }
  .uploadContainer {
    position: relative;
    height: 80px;
  }
</style>
